export const SET_FILTERS = 'PROFILE/SET_FILTERS';
export const SET_LOADER = 'PROFILE/SET_LOADER';
export const SET_ORDERS = 'PROFILE/SET_ORDERS';
